import { updateScreenMetaApi } from '@/modules';
import { useAppStateContext } from '@/shared';
import { version } from '../../../package.json';
import { screenInfoWithAppVersion } from '../functions';

const HALF_GB = 512 * 1024 * 1024;

const comparable = (info) =>
  JSON.stringify({
    ...info,
    storage: info?.storage && {
      freeBytes: Math.round(info.storage.freeBytes / HALF_GB),
    },
  });

const sameScreenInfo = (previous, next) =>
  Boolean(previous) && comparable(previous) === comparable(next);

export const useUtilFunctions = () => {
  const { appState, setAppState } = useAppStateContext();

  // =================================================================== API SECTION =====================================================================================
  const updateScreenMeta = async ({ screenId }) => {
    try {
      // current screen info with updated app version
      const screenInfo = await screenInfoWithAppVersion();

      // Only update when something the console shows has changed (free storage counts once it
      // moves by more than half a gigabyte).
      if (
        version === appState?.screenMeta?.appVersion &&
        sameScreenInfo(appState?.screenMeta, screenInfo)
      )
        return;

      const response = await updateScreenMetaApi({
        screenId,
        screenInfo: JSON.stringify(screenInfo),
      });

      if (response.status === 200) {
        setAppState((draft) => {
          draft.screenMeta = screenInfo;
        });
      } else {
        throw response;
      }
    } catch (error) {
      console.error('Error updating screen meta', error);
    }
  };

  return {
    updateScreenMeta,
  };
};
